import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import { withRouter } from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import ChatBoxForReEnter from './ChatBoxForReEnter';
import ChatBoxMobileForReEnter from './ChatBoxMobileForReEnter'

const styles = (theme) => ({
  body: {
    backgroundColor: "grey",
  },
  sigPad: {
    backgroundColor: "white",
    width: "100%",
    height: "100%",
  },
  container: {
    // margin: theme.spacing.unit * 5,
    //width: '50%',
    //minwidth: '30%',
    width: 400,
    height: 250,
    maxHeight: 300,
    minHeight: 200,
    //top: '10%',
    // left: '10%',
  },
  sigContainer: {
    maxWidth: "100%",
    minwidth: "30%",
    height: "80%",
    alignItems: "left",
    backgroundColor: "#fff",
  },
  button: {
    //width: '100%',
  },
  sigImage: {
    backgroundSize: "200px 50px",
    width: "200px",
    height: "200px",
    backgroundColor: "white",
  },
  pdfMargin: {
    // paddingRight: 10
  },
});

class ChatbotReEnterData extends Component {
  state = {
    windowHeight: undefined,
    windowWidth: undefined,
  };

  handleResize = () => {
    this.setState({
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    });
    console.log(
      "Window Size: window.innerHeight: " +
        window.innerHeight +
        " window.innerWidth: " +
        window.innerWidth +
        " div 4: " +
        window.innerWidth / 4
    );
  };

  componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  render() {
    const { classes } = this.props;
    let { trimmedDataURL } = this.state;
    return (
      <div>
          {this.state.windowWidth > 1220 && (
            <ChatBoxForReEnter lang={this.props.lang} caseId={this.props.caseId} style={{ marginBottom: "20px", width: "100vw", height: "90%" }} />
          )}

          {this.state.windowWidth <= 500 && (
            <ChatBoxMobileForReEnter
              lang={this.props.lang}
              caseId={this.props.caseId}
              style={{ marginTop: "20px", width: "100vw", height: "90%"  }}
            />
          )}
            
          {this.state.windowWidth <= 1220 && this.state.windowWidth > 500 && (
            <ChatBoxMobileForReEnter lang={this.props.lang} caseId={this.props.caseId} style={{ width: "100vw", height: "90%"  }} />
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    //userId: state.auth.userId,
    caseId: state.caseInfo.caseId,
    claimantUniqueId: state.caseInfo.claimantUniqueId,
    respondentUniqueId: state.caseInfo.respondentUniqueId,
    claimant_name: state.caseInfo.claimant_name,
    respondent_name: state.caseInfo.respondent_name,
    userType: state.caseInfo.userType,
    conversationId: state.caseInfo.conversationId,
    caseId: state.caseInfo.caseId,
    userType: state.caseInfo.userType,
    loadingCaseInfo: state.caseInfo.loading,
    loadingStepCompleted: state.onBoarding.loading,
    caseData: state.caseInfo.caseData,
    steps_completed:
      state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
    newAccount: state.caseInfo[`${state.caseInfo.userType}_newAccount`]
      ? state.caseInfo[
          `${state.caseInfo.userType}_newAccount`
        ] /*['newAccount']*/
      : null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAuth: (username, password) => dispatch(actions.auth(username, password)),
    onBoardingStepCompletion: (uniqueId, caseId, userType, step_completed) =>
      dispatch(
        actions.onBoardingStepCompletion(
          uniqueId,
          caseId,
          userType,
          step_completed
        )
      ),
    getCaseInfo: (caseId, uniqueId) =>
      dispatch(actions.getCaseInfo(caseId, uniqueId)),
    getUserInformation: (uniqueId) =>
      dispatch(actions.getUserInformation(uniqueId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(ChatbotReEnterData)));
